<template>
 <div >
<transition name="el-zoom-in-bottom">
    <div v-show="show" class="c-bg">
        <div class="button-group">
            <el-button @click="clickCancel" >取消</el-button>
            <el-button @click="clickDefine" :loading="loading" type="primary">{{loading?'正在通信':'确认'}}</el-button>
        </div>


     </div>
     </transition>
 </div>
</template>

<script>
export default {
name:'Mconfirm',
data(){
    return{

    }
},
props:{
     show:Boolean,
    loading:Boolean
},
methods:{
    clickCancel(){
        this.$emit('cancel')
    },
    clickDefine(){
        this.$emit('define')

    }
}


}
</script>

<style scoped>
.c-bg{
    border-top: 1px solid #d1dbe5;
    border-radius: 0px;
    background-color: #fff;
    overflow: hidden;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
    padding: 10px 0;
        position: fixed;
    width: 100%;
    right: 0;
    bottom: 0;
    z-index: 4;
   display: flex;
    justify-content: center;
}
.c-bg .button-group{
    width: 80%;
    display: flex;
    justify-content: space-between;
    max-width: 320px;
}
.c-bg .el-button{
    width: 48%;
    max-width: 150px;
}
.c-bg .el-button:last-child{
    margin-right: 0px;

}
</style>



// WEBPACK FOOTER //
// Mconfirm.vue?906e1e28